import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { StoreContext } from "../../../../../Store/Provider";
import clsx from "clsx";
import ShipmentCard from "../ShipmentCard/ShipmentCard";
import ShipmentDetails from "../ShipmentDetails/ShipmentDetails";
import Drawer from "@material-ui/core/Drawer";
import "./shipmentsListing.css";
import { getUserData, localStoragekey } from "../../../../Common/Utility/Utils";
import { HOST_URL } from "../../../../../Config";
import axios from "axios";
import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PropagateLoader from "react-spinners/PropagateLoader";
import ContainerDetails from "../SidebarData/ContainerDetails";
import { routeConstant } from "../../../../../Route/utils/routeConstant";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function SearchResults(props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(true);
  const [searchResult, setSearchResult] = useState([]);
  const [detailData, setDetailData] = useState({});
  const history = useNavigate();
  const [openalert, setOpenalert] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  useEffect(() => {
    if (context.shipmentNo) {
      getShipmentListing();
    } else {
      history("/Home/Shipments");
    }
  }, []);

  const getShipmentListing = async () => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });

    setLoading(true);

    const end_point = `${HOST_URL}api/v1/Shipment/SEARCH`;

    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };

    const params = {
      ShipmentId: `${context.shipmentNo}`,
      companyCode: userData.orgs,
      pageNumber: 1,
      pageSize: 20,
    };

    axios
      .post(end_point, params, {
        headers: header,
      })
      .then((res) => {
        setSearchResult(res.data.Value.shipments);
        setLoading(false);

        if (res.data.Value.shipments.length === 0) {
          setOpenalert(true);
          if (context.isUserLogin) {
            setTimeout(() => {
              history(routeConstant.ShipmentsListing);
            }, 3000);
          } else {
            setTimeout(() => {
              history(routeConstant.SearchShipment);
            }, 3000);
          }
        } else {
          handleDrawer(res.data.Value.shipments[0]);
          context.setSelectedIndex(0);
        }
        // context.setShipmentNo(res.data.Value.shipments[0].ShipmentId)
      })
      .catch((err) => {
        setSearchResult([]);
        setLoading(false);
      });
  };

  const handleDrawer = (data = {}) => {
    setDetailData(data);
    context.setSidebarContent("shipmentDetails");
    setOpen(true);
  };

  return (
    <div className="home">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert severity="error" onClose={handleClose}>
          No Shipments Found!
        </Alert>
      </Snackbar>
      <Header shipmentNo={context.shipmentNo} />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={
            ("menuBarDrawer",
            {
              paper: clsx(classes.drawerPaperleft, {
                [classes.drawerOpen]: context.menuBar,
                [classes.drawerClose]: !context.menuBar,
              }),
            })
          }
        >
          <Sidebar />
        </Drawer>
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
          style={
            open
              ? { marginRight: "0%", position: "relative" }
              : { marginRight: "-30%", zIndex: 1, position: "relative" }
          }
        >
          {loading ? (
            <div className="loadingClass">
              <PropagateLoader
                color={"rgba(var(--text-heading-dark))"}
                size={"1.5rem"}
              />
            </div>
          ) : (
            <div className="shipmentsListingHomeInner">
              <div className="shipmentsListingHomeInnerHeading">
                <span>Search Results</span>
                <CloseIcon
                  onClick={() => {
                    history(-1);
                  }}
                />
              </div>
              <div className="shipmentSearchBody">
                {searchResult.map((ele, index) => {
                  return (
                    <ShipmentCard
                      index={index}
                      key={ele.ShipmentId}
                      handleDrawer={handleDrawer}
                      loadedData={ele}
                    />
                  );
                })}
              </div>
            </div>
          )}
          {context.showMilestone ? (
            <ContainerDetails onDrawerChange={() => setOpen((prev) => !prev)} />
          ) : null}
        </main>
        <Drawer
          variant="persistent"
          className={classes.drawer}
          anchor="right"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className="shipmentsListingDetails">
            {open ? (
              <ShipmentDetails
                detailData={detailData}
                close={() => {
                  setOpen(false);
                  context.setSelectedIndex(null);
                }}
              />
            ) : null}
          </div>
        </Drawer>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  drawer: {
    width: "30%",
    flexShrink: 0,
    minWidth: "25rem",
  },
  drawerPaper: {
    width: "30%",
    minWidth: "25rem",
    top: "auto",
    height: "calc(100% - 3rem)",
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
    // [theme.breakpoints.up('sm')]: {
    //     width: theme.spacing(9) + 1,
    // },
  },
}));

export default SearchResults;
